import { AssetFluid } from './asset'
import { RichText } from './post'
import { Button } from './page'
import { CssEntry } from './contentfulAttributes'
import { BGVariants, HideOn } from './heroTextSection'

export enum CallToActionTags {
  TrustPilot = 'Trustpilot',
  TrustPilotStars = 'Trustpilot Stars',
}

export interface CTA {
  name: string
  variant: CTAVariants
  image: AssetFluid | null
  carouselImages: AssetFluid[] | null
  carouselLinks: CarouselLinks
  header: RichText
  text: RichText
  buttons: Button[]
  tags?: CallToActionTags[]
  contentful_id: string
  __typename: 'ContentfulCallToAction'
  css: CssEntry[] | null
  hideOn: HideOn
  backgroundColor: BGVariants
}
export interface CarouselLinks {
  links: ResumeSamples[]
}

export interface ResumeSamples {
  contentful_id: string
  __typename: 'ContentfulPostResumeSample'
  slug: string
  title: string
  occupation: string
  featuredImages: AssetFluid[]
}

export enum CTAVariants {
  Sidebar = 'Sidebar',
  CornerImage = 'Corner Image',
  Default = 'Default',
  Card = 'Card',
  Carousel = 'Carousel',
  FullWidthFooter = 'Full Width Footer',
  Drawer = 'Drawer',
  ResumeUpload = 'Resume Upload',
  UploadPage = 'Upload Page',
}
